module.exports = __webpack_public_path__ + "static/media/angle-right.5cd39ec0.svg";